module.exports = __webpack_public_path__ + "img/3.bcb7d7b5.jpg";